import { Directive, Input, HostBinding } from '@angular/core';
import { NavService } from '../nav.service';


@Directive({
  selector: '[navContent]',
  exportAs: 'nav-content-directive'
})
export class NavContentDirective {

  @Input() name: string = '';

  @HostBinding('class.nav-hidden') get isHidden(): boolean {
    return this.model.active && this.model.active.name !== this.name;
  }

  get model(): any {
    return this.navService.model;
  }

  constructor(private navService: NavService) {}

}
